var $ = jQuery.noConflict();

$(document).ready(function() {
    // Handle Vimeo video playback
    $('.video-text-block .vimeo-button').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var $button = $(this);
        var $videoWrap = $button.closest('.video-wrap');
        var playerId = $videoWrap.find('.vimeo-video').attr('id');
        
        // Initialise Vimeo player and trigger playback
        var player = document.getElementById(playerId);
        var data = { method: "play" };
        player.contentWindow.postMessage(JSON.stringify(data), "*");

        // Hide overlay elements and display video
        $videoWrap.find('.video-info .video-wrap__play').hide();
        $videoWrap.find('.video-info .video-wrap__bg').hide();
        $videoWrap.find('.vimeo-video').show();

        // Update video container state
        $videoWrap.addClass('interacted').removeClass('loading');
    });

    // Handle general play button interactions
    $('.video-text-block .video-wrap__play').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        var $button = $(this);
        $button.hide();
    });
});
